import React, {ReactNode} from 'react';
import {Box, Container} from '@mui/material';

interface Props {
	children: ReactNode;
	maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
	/** Hugs the bottom-right corner, for short viewports where every pixel of height counts. */
	isDense?: boolean;
}

const FabAreaWrapperBottomRight: React.FC<Props> = ({ children, maxWidth, isDense }) => <Box
	zIndex={1000}
	role="presentation"
	sx={{ position: 'fixed', bottom: isDense ? 12 : 40, right: 0 }}
>
	<Container maxWidth={maxWidth || false} disableGutters={isDense} sx={isDense ? { pr: 1.5 } : undefined}>
		<Box display='flex' justifyContent='flex-end'>
			{children}
		</Box>
	</Container>
</Box>;

export default FabAreaWrapperBottomRight;
